import { Button, Collapse, TableCell, TableRow } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import "react-datetime/css/react-datetime.css";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import PriceFormat from "../../../partials/priceFormat";
import TableFormat from "../../../partials/TableFormat";
import { toLocalTime } from "../../formatUTC";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import UserMembercard from "../userMembercard";
import MemberCard from "./memberCard";
import { styles } from "./styles";

const headCells = [
  {
    key: "code",
    numeric: false,
    disablePadding: false,
    label: "membercard_add_code",
  },
  {
    key: "title",
    numeric: false,
    disablePadding: false,
    label: "membercard_add_title",
  },
  {
    key: "price",
    numeric: false,
    disablePadding: false,
    label: "membercard_add_price",
  },
  {
    key: "value",
    numeric: false,
    disablePadding: false,
    label: "membercard_add_value",
  },
  {
    key: "expiredDays",
    numeric: false,
    disablePadding: false,
    label: "membercard_add_expired_days",
  },
  {
    key: "times",
    numeric: false,
    disablePadding: false,
    label: "membercard_add_times",
  },
  { key: "action", numeric: false, disablePadding: false, label: "action" },
];

class ListMemberCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "",
      orderBy: "",
      colorSnackbar: "white",
      selected: [],
      index: 0,
      data: [],
      listMemberCard: [],
      dialog: {
        messageConfirm: "",
        content: "",
      },
      collapse: [],
      flagOpen: false,
      memberCardSend: "",
    };
    this.mTable = React.createRef({});
    this.showDialogAddCustomer = this.showDialogAddCustomer.bind(this);
    this.handleSubmitDelete = this.handleSubmitDelete.bind(this);
  }
  componentWillMount() {
    this.props.onRef(null);
  }
  async componentDidMount() {
    this.props.onRef(this);
  }
  getList = async (payload = {}) => {
    let { rowsPerPage, page, search } = this.mTable.state;
    this.loading && this.loading.startLoading();
    let check = await this.props.getList({
      limit: rowsPerPage,
      page: page,
      search: search,
      ...payload,
    });
    this.loading && this.loading.stopLoading();
    if (check.code !== 1) this.mSnackbar.handleClick(check.message, "error");
  };
  handleDialogEditClose = () => {
    this.setState({ flagOpen: false });
  };
  showDialogAddCustomer(card) {
    this.setState({
      flagOpen: true,
      memberCardSend: card,
    });
  }
  handleChange = (value) => {
    this.getList({ branchCode: value });
  };
  isSelected = (id) => {
    return this.state.selected.indexOf(id) !== -1;
  };
  handleOpenCollapes = (id) => {
    const listMemberCard = this.props.listMemberCard;
    const { collapse } = this.state;
    for (var i = 0; i <= listMemberCard.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else {
        collapse[i] = false;
      }
    }
    this.setState(collapse);
  };

  async handleSubmitDelete(selected) {
    var { t } = this.props;
    this.loading.startLoading();
    let check = await this.props.deleteMemberCard({ ids: selected });
    this.loading.stopLoading();
    if (check.code === 1) {
      this.mSnackbar.handleClick(t("membercard_list_delete_successfully"));
      return true;
    } else {
      this.mSnackbar.handleClick(
        t("membercard_list_delete_unsuccessfully") + " " + check.message,
        "error"
      );
      return false;
    }
  }
  finishUpdate = (check) => {
    let { t } = this.props;
    this.handleOpenCollapes(-1);
    check.code === 1
      ? this.mSnackbar.handleClick(t("membercard_list_update_successfully"))
      : this.mSnackbar.handleClick(
          t("membercard_list_update_unsuccessfully") + " " + check.message,
          "error"
        );
    this.getList();
  };
  renderCollapse = (row, index) => {
    const { collapse = [] } = this.state;
    const listMemberCard = this.props.listMemberCard;
    let { classes } = this.props;
    return (
      <TableRow key={index} className={classes.tableRowHeight}>
        <TableCell
          colSpan={headCells.length + 1}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <MemberCard
              data={listMemberCard.find((e) => e.code === row.code)}
              finishUpdate={this.finishUpdate}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  actionColumn = (row, index) => {
    const listMemberCard = this.props.listMemberCard;
    let { t, classes } = this.props;
    let memberCardSend = listMemberCard.find((e) => e.code === row.code);
    return (
      <>
        <div className={classes.containerButton}>
          <Button
            size="small"
            onClick={(event) => this.showDialogAddCustomer(memberCardSend)}
            variant="outlined"
            color="primary"
            className={classes.buttonOnRow}
          >
            {t("sendButton")}
          </Button>
        </div>
      </>
    );
  };
  afterSend = (check) => {
    let { t } = this.props;
    if (check.code === 1) {
      this.mSnackbar.handleClick(
        t("user_membercard_send_membercard") +
          ' "' +
          this.state.memberCardSend.title +
          '" ' +
          t("voucher_uservoucher_successfully")
      );
      this.setState({ flagOpen: false });
    } else {
      this.mSnackbar.handleClick(
        t("user_membercard_send_membercard") +
          ' "' +
          this.state.memberCardSend.title +
          '" ' +
          t("voucher_uservoucher_unsuccessfully") +
          " " +
          check.message,
        "error"
      );
    }
  };
  render() {
    const { count, t, total, listMemberCard } = this.props;
    const { collapse, flagOpen, memberCardSend } = this.state;
    const { infoServiceBranch } = this.props.serviceBranchState;
    let ofBranch =
      infoServiceBranch && infoServiceBranch.branchName
        ? ` ${t("of")} ${infoServiceBranch.branchName}`
        : "";
    return (
      <React.Fragment>
        <Loading onRef={(id) => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          orderBy=""
          contentDialog={t(
            "membercard_list_do_you_want_to_delete_this_card_from_list"
          )}
          onDelete={this.handleSubmitDelete}
          title={t("membercard_all_membercard") + ofBranch}
          showFilter={false}
          placeholder={t("membercard_search_title_code")}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          isCollapse={true}
          collapse={collapse}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          getList={this.getList}
          showFilterBranch={true}
          handleChangeBranch={this.handleChange}
          infoServiceBranch={infoServiceBranch}
          actionColumn={this.actionColumn}
          rows={listMemberCard.map((row) => {
            return {
              id: row._id,
              code: row.code,
              title: row.title,
              price: <PriceFormat value={row.price} />,
              value: <PriceFormat value={row.value} />,
              expiredDays:
                !row.expiredDays ||
                (row.expiredDays && row.expiredDays === Number.MAX_SAFE_INTEGER)
                  ? t("membercard_un_specified")
                  : row.expiredDays,
              times:
                !row.times ||
                (row.times && row.times === Number.MAX_SAFE_INTEGER)
                  ? t("membercard_un_specified")
                  : row.times,
            };
          })}
        />
        {flagOpen ? (
          <div>
            <UserMembercard
              handleDialogEditClose={this.handleDialogEditClose}
              dialogOpen={flagOpen}
              memberCardSend={memberCardSend}
              afterSend={this.afterSend}
            />
          </div>
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }
}

ListMemberCard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  total: state.memberCards.total,
  count: state.memberCards.count,
  listMemberCard: state.memberCards.listMemberCard,
  currencyCode: state.setting.setting
    ? state.setting.setting.currencyCode
    : "VND",
  serviceBranchState: state.serviceBranch,
});

const mapDispatch = (dispatch) => ({
  deleteMemberCard: dispatch.memberCards.deleteById,
  getList: dispatch.memberCards.getList,
});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ListMemberCard)
  )
);
